// React glue of the Claude support: one assistant per app client (one signed-in account: App.tsx makes a new client
// for every login); the cloud knows the account from the session. The screen gallery and tests hand in their own
// (fake fetch) with provideAssistant().
import { createContext, useContext, useEffect, useSyncExternalStore } from 'react';
import { ClaudeAssistant, type AssistantView } from '../../ai/assistant.js';
import type { BrewcoreClient } from '../../core/index.js';
import { useMachine } from '../machine-context.js';

const assistants = new WeakMap<BrewcoreClient, ClaudeAssistant>();

export function provideAssistant(client: BrewcoreClient, assistant: ClaudeAssistant): void {
  assistants.set(client, assistant);
}

export function assistantFor(client: BrewcoreClient): ClaudeAssistant {
  let a = assistants.get(client);
  if (!a) {
    a = new ClaudeAssistant();
    assistants.set(client, a);
  }
  return a;
}

export function useAssistant(): { assistant: ClaudeAssistant; view: AssistantView } {
  const { client } = useMachine();
  const assistant = assistantFor(client);
  const view = useSyncExternalStore(assistant.subscribe, assistant.getSnapshot);
  useEffect(() => {
    void assistant.load();
  }, [assistant]);
  return { assistant, view };
}

const OpenSettings = createContext<(() => void) | null>(null);

/** Einstellungen → Claude from anywhere (App.tsx): the setup line, the card's menu and its key errors lead there. */
export const ClaudeSettingsLink = OpenSettings.Provider;

/** The way to Einstellungen → Claude, null where there is none (the screen gallery, tests). */
export function useOpenClaudeSettings(): (() => void) | null {
  return useContext(OpenSettings);
}
